export interface SymbiosisError {
    error: {
        code: number;
        message?: string;
    };
}
